"use strict";
var cmp = 'compareproducts',
    cmpItems = JSON.parse(localStorage.getItem(cmp));

class CompareItems extends HTMLElement {
    constructor() {
        super();
        this.getWlProducts(cmpItems);
    }
    getWlProducts(p) {
        var query = "",
            ajaxURL = "";

        if (p && p.length > 0) {
            query = p.join("%20OR%20id:");
            ajaxURL = `&q=id:${query}`;
        }

        fetch(`${this.dataset.url}${ajaxURL}`).then((response) => response.text()).then((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const wlProducts = html.querySelector("#compareProducts");
            const wlDiv = document.querySelector("#compareProducts");
            if (wlProducts && wlProducts.querySelector('.grid_bx')){
                wlDiv.innerHTML = wlProducts.innerHTML;
                wlDiv.classList.remove('hide');
                document.querySelector(".wlnull").classList.add('hide');
            }
        })
        .finally(() => {
            this.removeItem();
        })
        .catch((e) => {
            console.error(e);
        });
    }
    removeItem() {
        var _this = this,
            buttons = this.querySelectorAll(".remove-item");
        buttons.forEach((btn) => {
            var wraper = btn.closest('.gitem');
            btn.addEventListener("click", function (e) {
                const clindex = [...wraper.parentNode.children].indexOf(wraper);
                document.querySelectorAll(".compareList .row").forEach(r => r.children[clindex]?.remove());
                const id = this.dataset.id,
                    index = cmpItems.indexOf(id);
                cmpItems.splice(index, 1);
                localStorage.setItem(cmp, JSON.stringify(cmpItems));
                _this.checkEmpty();
            });
        });
    }
    checkEmpty() {
        if (cmpItems.length === 0) {
            document.querySelector("#compareProducts").classList.add('hide');
            document.querySelector(".wlnull").classList.remove('hide');
        }
    }
}
customElements.define("compare-items", CompareItems);